// import awaitSelector, { watchAwaitSelector } from "await-selector"

export const useSelectElement = (selector) => {
  const ele = ref(null)

  onMounted(async () => {
    // const el = document.querySelector(selector)
    // console.log(selector, el)
    // if (el) {
    //   ele.value = el
    // }

    await import("arrive")
    document.arrive(
      selector,
      {
        existing: true,
      },
      (el) => {
        ele.value = el
      }
    )

    document.leave(selector, () => {
      ele.value = null
    })
  })

  onBeforeUnmount(() => {
    document.unbindArrive(selector)
    document.unbindLeave(selector)
  })

  const route = useRoute()
  watch(
    () => route.path,
    () => {
      ele.value = null
    }
  )

  return ele
}
